import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { apiCall } from '../../components/special/apiCall';
import SimpleFileUploadButton from 'components/button/SimpleFileUploadButton';
import TextDate from '../../components/text/TextDate';
import TextAmount from 'components/text/TextAmount';
import {useErrorContext} from 'components/messages/ErrorBox';
import { usePageLoadingContext } from '../../components/messages/PageLoading';
import { HeimavellirClaimList } from './HeimavellirClaimList';
import { useLocale } from '../../components/special/LanguageProvider';


const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;

export const HeimavellirFileImport = (props)  => {
  const [claimList, setClaimList] = useState([]);
  const [claimResult, setClaimResult] = useState(null);
  const [step, setStep] = useState(0);    
  const [fileStep1, setFileStep1] = useState(null);    
  const { t } = useLocale();
  const setCheckErrorItems = useErrorContext();
  const setIsPageLoading = usePageLoadingContext();

  
  
   const isResultOk = (obj) => {
        if ((obj != null) && (obj.error != undefined)){
            setCheckErrorItems([obj]);
            return null;
        }
        return obj;
    }


    const loadTextFile = async (file) => {        
        let dataForm = new FormData();        
        dataForm.append('file', file);
        dataForm.append('name', file.name);
        const fileData = await apiCall(`${BASE_URL}/features/upload`,{data: dataForm, contentType: 'multipart/form-data', method: 'post'});
        if (isResultOk(fileData)){
           // console.log("file uploaded", fileData);
           // console.log("file uploaded len", fileData.fileData.length);
            return fileData;
        }
        return null;
    }

    const loadStep1DataFromFile = async (file) => {
        setIsPageLoading(true);
        let loadedFile = await loadTextFile(file);
        if (loadedFile != null){            
            const dataFileResult = await apiCall(`${BASE_URL}/features/heimavellir/inputfile`,{ method: 'post', data: loadedFile});
            if (isResultOk(dataFileResult)){                
                setFileStep1(loadedFile);
                setClaimList(dataFileResult);
                gotoNextStep();
            }
        }
        setIsPageLoading(false);
    };
  

    const registerClaims = async () => {  
        setIsPageLoading(true);  
        let data = {
            claims : claimList
        };
        const createResult = await apiCall(`${BASE_URL}/features/heimavellir/createclaims`,{ method: 'post', data: data});
        if (isResultOk(createResult)){            
            setClaimResult(createResult);
            setClaimList(null);
            gotoNextStep();                       
        }
        setIsPageLoading(false);
    }

    const startOver = () => {
        setIsPageLoading(true);  
        setClaimList(null);
        setFileStep1(null);        
        setStep(0);
        setIsPageLoading(false);  
    }

    const gotoNextStep = () => {
      setStep(step+1);
    }    

  return (
    <div>
      <h1 className="text-red text-32">{t("Heimavellir skráar innlestur")}</h1>    
       
       {/* TODO -> Spinner */}
        {fileStep1 && 
       <div className="grid">
                <div className="col s1of1 text-right">
                    {(step < 4) && <button className="button clear gutter-right" onClick={startOver}>{t("Byrja aftur")}</button>}
                </div>
        </div>}                    

        {step === 0 && (
            <div className="grid box" id="skref1">
                <div className="col s1of1">
                    <div className="grid">
                        <div className="col s1of2">
                            <h3>{t("Excel skrá")}</h3>
                        </div>
                        <div className="col s1of2 text-right">
                            <p>{t("Skref") + " 1 " + t("af") + " 2 "}</p>
                        </div>
                    </div>
                </div>
                <div className="col s1of1">
                    <div className="grid">
                        <div className="col s1of2">
                            <p>{t("Til að hlaða inn málum þarf að hlaða upp skrá á excel formi sem hefur ákveðið skipulag")}</p>
                            <p>{t("Athuga skal að engar kröfur eru stofnaðar í kerfinu fyrr en á lokaskrefinu. ")}</p>
                        </div>
                        <div className="col s1of2 text-right">
                            <div className="col s1of1">
                              <div className="grid">
                                <div className="col s1of1">
                                    {!fileStep1 && (<span>{t("Hlaða inn skrá")}</span>)}
                                    {fileStep1 && (<span>{t("Búið að hlaða inn skrá")}</span>)}
                                </div>
                                <div className="col s1of1">
                                {!fileStep1 && <SimpleFileUploadButton fileType=".xlsx" onSelectedFile={loadStep1DataFromFile} />}
                                </div>
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col s1of1 text-right">
                    {fileStep1 && <button className="button blue" onClick={gotoNextStep}>{t("Næsta skref")}</button>}
                </div>
            </div>
            )
        }       
        {step === 1 && (
            <div className="grid box" id="skref3">
            <div className="col s1of1">
                <div className="grid">
                    <div className="col s1of2">
                        <h3>{t("Kröfur")}</h3>
                    </div>
                    <div className="col s1of2 text-right">
                        <p>{t("Skref") + " 2 " + t("af") + " 2 "}</p>
                    </div>
                </div>
            </div>
            <div className="col s1of1">
                <div className="grid">
                    <div className="col s1of2">
                        <p>{t("Þetta skref er til þess að stofna þær kröfur sem eru í listanum hér fyrir neðan.")}</p>
                        <p>{t("Athuga að þessi aðgerð getur tekið smá tíma.")}</p>
                    </div>
                    <div className="col s1of2 text-right">
                        
                    </div>
                </div>
            </div>
            <div className="col s1of1 text-right">
                <button className="button blue" onClick={registerClaims}>{t("Stofna kröfur")}</button>
            </div>
            </div>
        )}

        {step === 2 && (
            <div className="grid box" id="skref4">
                <div className="col s1of1 text-center">
                    <h3>{t("Kröfur hafa verið stofnaðar")}</h3>
                </div>                
                <div className="col s1of1 text-center">
                    <button className="button blue" onClick={startOver}>{t("Lokið")}</button>
                </div>
            </div>
        )}
        
        {claimList && claimList.length > 0 && <HeimavellirClaimList list={claimList} />} 

       {step === 2 && claimResult && (
           <div className="grid">
                <div className="col s1of1"> 
                    <h3>{t("Kröfur sem voru stofnaðar")}</h3>
                </div>
                <div className="col s1of1">                     
                    <HeimavellirClaimList list={claimResult.created} isClaimNumber={true} />
                </div>

                <div className="col s1of1"> 
                    <h3>{t("Færslur sem ekki var hægt að stofna kröfur")}</h3>
                </div>
                <div className="col s1of1">
                    <HeimavellirClaimList list={claimResult.notCreated} />
                </div>                
           </div>
       )}

        

    </div>
  );
};
